import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "users",
    pageTitle: "Users",
    displayName: "users",
    columns,
    searchFields,
    searchPlaceholder: "e.g. name:hossam, email:example@example.com",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
